// extracted by mini-css-extract-plugin
export default {"container":"UploadFile-container___d2bdD"};